const o = " ";
export {
  o as NBSP_CODE
};
//# sourceMappingURL=index.es5554.js.map
